// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { Box } from '@mui/system';
import pxToEm from 'theme/pxToEm';

interface Props {
  left?: number;
  bottom?: number;
  right?: number;
  top?: number;
}

export const ScrollFabContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    !['right', 'bottom', 'left', 'top'].includes(prop),
})<Props>`
  position: fixed;
  ${({ left }) => left && `left: ${pxToEm(left)};`}
  ${({ bottom }) => bottom && `bottom: ${pxToEm(bottom)};`}
    ${({ right }) => right && `right: ${pxToEm(right)};`}
    ${({ top }) => top && `top: ${pxToEm(top)};`}
    z-index: 3;
  svg {
    transform: rotate(180deg);
  }
`;
